import keys from '@debbie/common/dist/cache/keys.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { creditorsEntity } from '@debbie/cortex/dist/creditors/index.js';
import { useIsAdmin } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import React from 'react';
import RichTextField from '../RichTextField.js';
const CreditorNotes = (props) => {
    const { creditor } = props;
    const isAdmin = useIsAdmin();
    const updateNote = async (html) => {
        if (!creditor) {
            return;
        }
        await creditorsAPI.update(creditor.creditorId, {
            notes: html,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
    };
    return (React.createElement(RichTextField, { value: creditor.notes, header: 'Note', canUpdate: isAdmin ?? false, onUpdate: updateNote, style: { padding: '10px 35px 10px 20px' } }));
};
export default CreditorNotes;
//# sourceMappingURL=CreditorNotes.js.map